// extracted by mini-css-extract-plugin
export default {"modal__overlay":"modal__overlay__IhdBL","modal":"modal__MV-22","modal--animated":"modal--animated__eCuOG","fadeInUp":"fadeInUp__5uDTH","modal__message":"modal__message__EHZkN"};